import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './inspection.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const inspectionEntity = useAppSelector(state => state.inspection.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="inspectionDetailsHeading">
          <Translate contentKey="fleetSenseApp.inspection.detail.title">Inspection</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{inspectionEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.inspection.name">Name</Translate>
            </span>
          </dt>
          <dd>{inspectionEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.inspection.description">Description</Translate>
            </span>
          </dt>
          <dd>{inspectionEntity.description}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="fleetSenseApp.inspection.type">Type</Translate>
            </span>
          </dt>
          <dd>{inspectionEntity.type}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspection.company">Company</Translate>
          </dt>
          <dd>{inspectionEntity.company ? inspectionEntity.company.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspection.inspectionItem">Inspection Item</Translate>
          </dt>
          <dd>
            {inspectionEntity.inspectionItems
              ? inspectionEntity.inspectionItems.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {inspectionEntity.inspectionItems && i === inspectionEntity.inspectionItems.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/inspection" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/inspection/${inspectionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InspectionDetail;
